var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({ref:"inputRef",attrs:{"prefix":_vm.currency},on:{"blur":function($event){return _vm.$emit('blur', $event)}}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }